import {
  careTypeParagraphCopy,
  careTypeTitleCopy,
  positivelyRatedParagraphCopy,
} from "./shared"

export default ({
  locationName,
  totalHomeCareCount,
  careType,
  regulatoryBody,
  positivelyRatedCount,
}) => [
  {
    question: `How many home care agencies are there in ${locationName}?`,
    answer:
      totalHomeCareCount === 1
        ? `There is ${totalHomeCareCount} home care agency in ${locationName}, who specialises in offering professional care to the elderly in the comfort of your own home.`
        : `There are ${totalHomeCareCount} home care agencies in ${locationName}, who specialise in offering professional care to the elderly in the comfort of your own home.`,
  },
  {
    question: careTypeTitleCopy(careType, locationName),
    answer:
      totalHomeCareCount === 1
        ? `${careTypeParagraphCopy(careType, locationName, regulatoryBody)}`
        : `${careTypeParagraphCopy(
            careType,
            locationName,
            regulatoryBody,
          )} ${positivelyRatedParagraphCopy(
            "home care agencies",
            locationName,
            totalHomeCareCount,
            positivelyRatedCount,
          )}.`,
  },
]
